const VIDEO_TYPES = {
  MP4: 'video/mp4',
}

const HTML5_VIDEO_NOT_SUPPORTED_TEXT = 'Tarayıcınız HTML5 videoyu desteklemiyor.';

export {
  VIDEO_TYPES,
  HTML5_VIDEO_NOT_SUPPORTED_TEXT,
}
